export default{
    "title": " Vé số Việt - Điện toán 123 - Lô Tô vé số Online",
    "canonical": "st",
    "description": "Đặt mua Xổ số Online trực tuyến, mua loto so xo online trên ứng dụng di động với vé số in từ máy chính quy hợp pháp nhà nước của công ty Xổ số Việt!",
    "keyword": "vietlott, mua vé, vé số, mua hộ, trúng thưởng, mega, power, keno, xổ số, điện toán, miễn phí, nhanh chóng, tỷ phú",
    "url": "https://vietlott.mobi",
    "thumb": "https://vietlott.mobi/img/logo/logo.png"
}